<template>
  <div class="OJProblemManagement">
    <div class="clearfix top">
      <div class="fl" style="margin-right:10px">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="标题">
            <el-input v-model="form.title" prefix-icon="el-icon-search" placeholder="请输入标题、题单编号" size="mini" clearable @keyup.enter.native="search"></el-input>
          </el-form-item>
          <el-form-item label="所属">
            <el-select v-model="form.isPlatform" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平台" value="1"></el-option>
              <el-option label="校区" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题单类型">
            <el-select v-model="form.oj_problem_list_type_id" filterable placeholder="请选择" clearable>
              <el-option v-for="item in ojProblemListTypeList1" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div class="fl">
        <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>

        <el-button type="primary" @click="add" icon="el-icon-plus" size="mini">新增题单</el-button>
      </div>

    </div>
    <el-divider></el-divider>
    <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
      <el-table-column prop="sort_num" label="排序号">
      </el-table-column>

      <el-table-column prop="title" label="名称">
      </el-table-column>
      <el-table-column prop="realname" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.oj_problem_list_type_id === null">--</span>
          <span v-else>
            <span>{{ scope.row.totalInfo.title }}</span>
          </span>

        </template>
      </el-table-column>
      <el-table-column prop="realname" label="创建人">
        <template slot-scope="scope">
          <span v-if="scope.row.realname != null">{{ scope.row.realname }}</span>
          <span v-else>格小C</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="账号">
        <template slot-scope="scope">
          <span v-if="scope.row.realname != null">{{ scope.row.name }}</span>
          <span v-else>格小C</span>
        </template>
      </el-table-column>
      <el-table-column prop="problem_num" label="题目数量">
      </el-table-column>
      <el-table-column prop="post_state" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.post_state === 1">启用</span>
          <span v-else>停用</span>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)" size="mini">编辑</el-button>
          <el-button type="text" @click="goDetaisl(scope.row)" size="mini">管理</el-button>
          <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix" style="margin-top: 20px;">

      <div class="fr" style=" text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 添加 -->
    <el-dialog :title="dialogVisibleTitle" z-index="1000" :visible.sync="dialogVisible" v-if="dialogVisible" width="80%">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
        <el-form-item label="排序号" prop="sort_num" required>
          <el-input-number v-model="addForm.sort_num" :precision="1" :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-select v-model="addForm.post_state" placeholder="请选择活动区域">
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题单类型">
          <el-select v-model="addForm.oj_problem_list_type_id" filterable placeholder="请选择" clearable>
            <el-option v-for="item in ojProblemListTypeList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题单名称" prop="title" required>
          <el-input v-model="addForm.title" placeholder="请输入题单名称"></el-input>
        </el-form-item>
        <el-form-item label="题单描述" prop="description" required>
          <Tinymce v-model="addForm.description"></Tinymce>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button type="primary" @click="submit('addForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";

import {
  adminAddOrUpdateOjProblemList,
  adminGetOjProblemListList,
  adminDeleteOjProblemList,
  adminGetOjProblemListTypeListWithOutP

}
  from "@/api/adminOj.js";
export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      firstTime: true,
      ojProblemListTypeList1: [],
      ojProblemListTypeList: [],
      difficultyId: '',
      addForm: {
        oj_problem_list_type_id: '',
        post_state: '1',
        sort_num: 0,
        title: '',
        description: ''
      },
      form: {
        isPlatform: '1',
        oj_problem_list_type_id: '',

      },
      dialogVisible: false,
      dialogVisibleTitle: '新增题单',
      page_no: 1,
      page_size: 20,
      total: 20,
      keyword: '',
      tableData: [

      ],
      rules: {
        title: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: ["change", "blur"],
          }
        ],
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
            trigger: ["change", "blur"],
          }
        ],

        description: [
          {
            required: true,
            message: "请输入题单描述",
            trigger: ["change", "blur"],
          }
        ],
      },
    }
  },
  activated() {
    if (this.firstTime === false) {
      this.adminGetOjProblemListList();
    }

  },
  mounted() {
    if (this.firstTime === true) {
      this.adminGetOjProblemListList();
    }
    this.adminGetOjProblemListTypeListWithOutList()
  },
  methods: {
    search() {
      this.page_no = 1
      this.adminGetOjProblemListList()
    },
    adminGetOjProblemListTypeListWithOutList() {
      adminGetOjProblemListTypeListWithOutP({}).then((res) => {
        console.log(res);
        this.ojProblemListTypeList1 = res.ojProblemListTypeList
      })
    },
    adminGetOjProblemListTypeListWithOutP() {
      adminGetOjProblemListTypeListWithOutP({}).then((res) => {
        console.log(res);
        this.ojProblemListTypeList = res.ojProblemListTypeList
        console.log(this.ojProblemListTypeList, 656235);
      })
    },
    adminGetOjProblemListList() {
      adminGetOjProblemListList({
        ...this.form,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.tableData = res.ojProblemlistList
        this.total = res.total
      })
    },
    //关闭
    close() {
      this.$refs["addForm"].resetFields();
      this.dialogVisible = false
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemList({
              id: this.difficultyId,
              ...this.addForm
            }).then(() => {
              this.$message.success('修改成功!')
              this.close()
              this.adminGetOjProblemListList()

            })
          } else {
            adminAddOrUpdateOjProblemList({
              ...this.addForm
            }).then(() => {
              this.$message.success('添加成功!')
              this.close()
              this.adminGetOjProblemListList()

            })
          }
        }
      });
    },
    del(row) {
      this.firstTime = false
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjProblemList({
          id: row.id
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetOjProblemListList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjProblemListList()

    },
    add() {
      this.difficultyId = ''
      this.oj_problem_list_type_id = ''
      this.addForm.sort_num = 0
      this.addForm.title = null
      this.addForm.description = null
      this.adminGetOjProblemListTypeListWithOutP()
      this.dialogVisible = true
      this.dialogVisibleTitle = '新增题单'
    },
    edit(row) {
      this.firstTime = false
      this.difficultyId = row.id
      this.addForm.sort_num = row.sort_num
      this.addForm.post_state = row.post_state.toString()
      this.addForm.oj_problem_list_type_id = row.oj_problem_list_type_id
      this.addForm.title = row.title
      this.addForm.description = row.description
      // this.adminGetOjProblemListTypeListWithOutP()
      this.dialogVisible = true
      this.dialogVisibleTitle = '编辑题单'
      console.log('this.addForm:', this.addForm)
    },
    goDetaisl(row) {
      this.firstTime = false

      this.$router.push({
        name: 'subjectDetails',
        query: {
          description: row.description,
          realname: row.realname,
          problemlist_id: row.id,
          title: row.title,
          educational: row.educational_institution_id,
        }
      })
    }

  }

}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  margin: 10px;
  padding: 20px;

  background: white;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>